import { render, staticRenderFns } from "./AccidentEdit.vue?vue&type=template&id=49e30038&"
import script from "./AccidentEdit.vue?vue&type=script&lang=js&"
export * from "./AccidentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports